"use client"; // Asegura que solo se ejecute en el cliente

import React from "react";
import { SelectStyle } from "./Select.styled";
import { SingleValue } from "react-select";
import { useSelector } from "react-redux";
import { ITheme } from "constants/interfaces/theme.interface";

interface Option {
    value: string;
    label: string;
}

interface SelectCustomProps {
    options: Option[];
    onChange?: (selectedOption: SingleValue<Option>) => void;
    placeHolder : string,
    value?: SingleValue<Option>;
    isClereable : Boolean
}


const SelectCustom: React.FC<SelectCustomProps> = ({ options, onChange, placeHolder, value, isClereable = false }) => {
  const theme : ITheme = useSelector((state: any) => state.persistedThemeReducer.theme);

    return (
        <SelectStyle
            options={options}
            isSearchable
            placeholder={placeHolder}
            value={value}
            onChange={(selectedOption) => {
                if (onChange) {
                    onChange(selectedOption as SingleValue<Option>);
                }
            }}
            styles={{
                control: (base) => ({
                    ...base,
                    backgroundColor : theme.CHOOSEN.SELECT_BACKGROUND,
                    color : theme.CHOOSEN.SELECT_COLOR
                }),
                menu: (base) => ({
                    ...base,
                    backgroundColor : theme.CHOOSEN.MENU_BACKGROUND,
                    color : theme.CHOOSEN.MENU_COLOR,
                }),
                option: (base, { isFocused, isSelected }) => ({
                    ...base,
                    backgroundColor: isFocused || isSelected ? theme.CHOOSEN.MENU_BACKGROUND_FOCUS : theme.CHOOSEN.MENU_BACKGROUND,
                    color : theme.CHOOSEN.SELECT_COLOR
                }),
                singleValue: (base) => ({
                    ...base,
                    color: theme.CHOOSEN.SINGLE_COLOR
                }),
                input: (base) => ({
                    ...base,
                    color: theme.CHOOSEN.SELECT_COLOR
                }),
            }}
        />
    );
};

export default SelectCustom;
